import { Component } from 'react'

export default class Terms extends Component {
  componentDidMount() {
    window.location.href = 'https://www.engagespark.com/terms-of-service'
  }

  render() {
    return null
  }
}
